import React, { useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import BaseButton from "../../../main/components/BaseButton";
import { MainContext } from "../../../main/context/MainContextProvider";

type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
};

const ConfirmationDialogUser: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  onClose,
}) => {
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        {title}
      </DialogHeader>
      <DialogContent
        sx={{
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <BaseButton
          sx={{
            backGroundColor: primary,
            borderColor: primary,
            height: "35px",
            width: "95px",
            "& .MuiTypography-root": {
              color: primary,
            },
            "&:hover": {
              borderColor: primary,
              backgroundColor: primary,
              color: primary,
              "& .MuiTypography-root": {
                color: "#FFFFFF",
              },
            },
          }}
          onClick={onCancel}
          title="Continuar"
        />
        <DangerBaseButton onClick={onConfirm} title="Descartar" />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialogUser;
